import { defineStore } from 'pinia'

export const useFeaturesStore = defineStore('features', {
  state: () => ({
    enabled: [],
    isLoading: null,
  }),

  getters: {
    isEnabled: (state) => (name) => state.enabled.includes(name),
  },

  actions: {
    async fetchFeatures() {
      this.isLoading = true

      const data = await useGetApi('features/enabled')
      this.enabled = data

      this.isLoading = false
    },
  },
})
